/* eslint-disable max-lines-per-function */
import discount from '../helpers/discount';

export default function builder() {
  const reset = () => ({ ecommerce: null });

  const signUpEvent = () => ({
    event: 'sign_up',
    method: 'Miliboo',
  });

  const signInEvent = () => ({
    event: 'login',
    method: 'Miliboo',
  });

  const viewItemsListEvent = (products, listingId, listingName) => ({
    event: 'view_item_list',
    ecommerce: {
      item_list_id: listingId,
      item_list_name: listingName,
      items: Object.keys(products).slice(0, 16).map((product, key) => {
        const price = products[product].prices?.priceIncludingAllTaxes || 0;
        const discountFactor = products[product].prices?.discountFactor || 0;
        const discountedPrice = products[product].prices?.roundedDiscountAmountIncludingAllTaxes || 0;
        const eventPrice = discountFactor > 0 ? discountedPrice : price;
        return {
          index: key,
          item_id: products[product].sku,
          item_name: products[product].name,
          item_category: products[product].category?.name,
          price: +eventPrice.toFixed(2),
          discount: price && discountFactor > 0 ? +(+price - +discountedPrice).toFixed(2) : 0,
        };
      }),
    },
  });

  const viewItemEvent = (product, prices, netwaveCategoryCode) => {
    const price = prices?.priceIncludingAllTaxes?.toFixed(2) || 0;
    const discountFactor = prices?.discountFactor || 0;
    const discountedPrice = prices?.discountedPriceIncludingAllTaxes?.toFixed(2) || 0;

    return {
      event: 'view_item',
      custom: {
        category_id: netwaveCategoryCode,
      },
      ecommerce: {
        value: discountFactor > 0 ? +discountedPrice : +price,
        currency: product.prices[0]?.currency_alpha3_code,
        items: [
          {
            item_id: product.sku,
            item_name: product.name,
            item_category: product.category.name,
            price: discountFactor > 0 ? +discountedPrice : +price,
            discount: price && discountFactor > 0 ? +(+price - +discountedPrice).toFixed(2) : 0,
          },
        ],
      },
    };
  };

  /**
   * Not found in Legacy and not used nor checked here
   */
  const { getCurrentDiscount } = discount();
  const addToWishlistEvent = (product) => {
    const currentDiscount = getCurrentDiscount(product.prices?.discounts);
    const price = product.prices?.price?.formated_price_incl_taxes;

    return {
      event: 'add_to_wishlist',
      ecommerce: {
        items: [
          {
            item_name: product.name,
            item_id: product.sku,
            discount: currentDiscount
              ? (price - currentDiscount.formated_price_incl_taxes).toFixed(2)
              : 0,
            price,
            item_category: product.category?.name,
            quantity: 1,
            item_variant: product.variation_code ?? '',
          },
        ],
      },
    };
  };

  const addToCartEvent = (product, quantity, prices, refurbishedProduct = null) => {
    const price = prices?.priceIncludingAllTaxes ?? 0;
    const discountFactor = refurbishedProduct ? refurbishedProduct.prices?.discountFactor : prices?.discountFactor || 0;
    const discountedPrice = refurbishedProduct ? refurbishedProduct.prices?.priceIncludingAllTaxes : prices?.discountedPriceIncludingAllTaxes || 0;
    const eventPrice = discountFactor > 0 ? discountedPrice : price;

    return {
      event: 'add_to_cart',
      ecommerce: {
        value: +(eventPrice * quantity).toFixed(2),
        currency: product.prices?.[0]?.currency_alpha3_code,
        items: [
          {
            item_id: product.sku,
            item_name: product.name,
            item_category: product.category.name,
            price: +eventPrice.toFixed(2),
            discount: price && discountFactor > 0 ? +(+price - +discountedPrice).toFixed(2) : 0,
            quantity,
            condition: refurbishedProduct ? 'refurbished' : 'new',
          },
        ],
      },
    };
  };

  const addSerenityPackToCartEvent = (serenityPack) => {
    const priceString = serenityPack.displayablePrice;
    const normalized = priceString.replace(/[^\d,.-]/g, '');
    const price = parseFloat(normalized.replace(',', '.'));

    return {
      event: 'add_to_cart',
      ecommerce: {
        currency: 'EUR',
        value: price,
        items: [
          {
            item_id: '20',
            item_name: 'Assurance',
            item_category: 'Services',
            price,
            discount: 0,
            quantity: 1,
          },
        ],
      },
    };
  };

  const viewCartEvent = (cart, currency = null) => ({
    event: 'view_cart',
    ecommerce: {
      value: cart.amounts?.totalAmount,
      currency: currency?.alpha3_code,
      items: Object.keys(cart.items).map((item, key) => {
        const itemPrice = cart.items[item].product?.price?.priceIncludingAllTaxes || 0;
        const discountFactor = cart.items[item].product?.price?.discountFactor || 0;
        const discountedPrice = cart.items[item].product?.price?.discountedPriceIncludingAllTaxes || 0;
        const eventPrice = discountFactor > 0 ? +discountedPrice : +itemPrice;
        return {
          index: key,
          item_id: cart.items[item].product?.category?.code === 'serenity_pack' ? '20' : cart.items[item].product?.sku,
          item_name: cart.items[item].product?.isSerenityPack ? 'Assurance' : cart.items[item].product?.name,
          item_category: cart.items[item].product?.isSerenityPack ? 'Services' : cart.items[item].product?.category?.name,
          price: +eventPrice.toFixed(2),
          discount: itemPrice && discountFactor > 0 ? +(+itemPrice - +discountedPrice).toFixed(2) : 0,
          quantity: cart.items[item].quantity,
          condition: cart.items[item].product?.reconditionned ? 'refurbished' : 'new',
        };
      }),
    },
  });

  const removeFromCartEvent = (item, quantity = null) => {
    const itemPrice = item.product?.price?.priceIncludingAllTaxes;
    const discountFactor = item.product?.price?.discountFactor;
    const discountedPrice = item.product?.price?.discountedPriceIncludingAllTaxes;
    const eventPrice = discountFactor > 0 ? discountedPrice : itemPrice || 0;
    return {
      event: 'remove_from_cart',
      ecommerce: {
        items: [
          {
            item_id: item.product?.sku,
            item_name: item.product?.name,
            item_category: item.product?.category?.name,
            price: +eventPrice.toFixed(2),
            discount: itemPrice && discountFactor > 0 ? +(+itemPrice - +discountedPrice).toFixed(2) : 0,
            quantity: quantity || item.quantity,
            condition: item.product?.reconditionned ? 'refurbished' : 'new',
          },
        ],
      },
    };
  };

  const removeSerenityPackFromCartEvent = (serenityPack) => {
    const normalized = serenityPack.displayablePrice.replace(/[^\d,.-]/g, '');
    const price = parseFloat(normalized.replace(',', '.'));
    return {
      event: 'remove_from_cart',
      ecommerce: {
        items: [
          {
            item_id: '20',
            item_name: 'Assurance',
            item_category: 'Services',
            price,
            discount: 0,
            quantity: 1,
          },
        ],
      },
    };
  };

  const beginCheckoutEvent = (orderInformation) => ({
    event: 'begin_checkout',
    ecommerce: {
      value: orderInformation.formated_products_amount,
      currency: orderInformation.currency?.alpha3_code,
      items: Object.keys(orderInformation.items).map((item, key) => {
        const itemPrice = orderInformation.items[item].product?.priceDto?.priceIncludingAllTaxes || 0;
        const discountFactor = orderInformation.items[item].product?.priceDto?.discountFactor || 0;
        const discountedPrice = orderInformation.items[item].product?.priceDto?.discountedPriceIncludingAllTaxes || 0;
        const eventPrice = discountFactor > 0 ? discountedPrice : itemPrice;
        return {
          index: key,
          item_id: orderInformation.items[item].product?.category?.code === 'serenity_pack' ? '20' : orderInformation.items[item].product?.sku,
          item_name: orderInformation.items[item].product?.category?.code === 'serenity_pack' ? 'Assurance' : orderInformation.items[item].product?.name,
          item_category: orderInformation.items[item].product?.category?.code === 'serenity_pack' ? 'Services' : orderInformation.items[item].product?.category?.name,
          price: +eventPrice.toFixed(2),
          discount: itemPrice && discountFactor > 0 ? +(+itemPrice - +discountedPrice).toFixed(2) : 0,
          quantity: orderInformation.items[item].quantity,
          condition: orderInformation.items[item].product?.reconditionned ? 'refurbished' : 'new',
        };
      }),
    },
  });

  const addShippingInfoEvent = (orderInformation) => ({
    event: 'add_shipping_info',
    ecommerce: {
      value: orderInformation.formated_products_amount,
      currency: orderInformation.currency?.alpha3_code,
      items: Object.keys(orderInformation.items).map((item, key) => {
        const itemPrice = orderInformation.items[item].product?.priceDto?.priceIncludingAllTaxes || 0;
        const discountFactor = orderInformation.items[item].product?.priceDto?.discountFactor || 0;
        const discountedPrice = orderInformation.items[item].product?.priceDto?.discountedPriceIncludingAllTaxes || 0;
        const eventPrice = discountFactor > 0 ? discountedPrice : itemPrice || 0;
        return {
          index: key,
          item_id: orderInformation.items[item].product?.category?.code === 'serenity_pack' ? '20' : orderInformation.items[item].product?.sku,
          item_name: orderInformation.items[item].product?.category?.code === 'serenity_pack' ? 'Assurance' : orderInformation.items[item].product?.name,
          item_category: orderInformation.items[item].product?.category?.code === 'serenity_pack' ? 'Services' : orderInformation.items[item].product?.category?.name,
          price: +eventPrice.toFixed(2),
          discount: itemPrice && discountFactor > 0 ? +(+itemPrice - +discountedPrice).toFixed(2) : 0,
          quantity: orderInformation.items[item].quantity,
          condition: orderInformation.items[item].product?.reconditionned ? 'refurbished' : 'new',
        };
      }),
    },
  });

  const addPaymentInfoEvent = (orderInformation, method) => ({
    event: 'add_payment_info',
    ecommerce: {
      value: orderInformation.formated_products_amount,
      currency: orderInformation.currency?.alpha3_code,
      payment_type: method,
      items: Object.keys(orderInformation.items).map((item, key) => {
        const itemPrice = orderInformation.items[item].product?.priceDto?.priceIncludingAllTaxes || 0;
        const discountFactor = orderInformation.items[item].product?.priceDto?.discountFactor || 0;
        const discountedPrice = orderInformation.items[item].product?.priceDto?.discountedPriceIncludingAllTaxes || 0;
        const eventPrice = discountFactor > 0 ? discountedPrice : itemPrice || 0;
        return {
          index: key,
          item_id: orderInformation.items[item].product?.category?.code === 'serenity_pack' ? '20' : orderInformation.items[item].product?.sku,
          item_name: orderInformation.items[item].product?.category?.code === 'serenity_pack' ? 'Assurance' : orderInformation.items[item].product?.name,
          item_category: orderInformation.items[item].product?.category?.code === 'serenity_pack' ? 'Services' : orderInformation.items[item].product?.category?.name,
          price: +eventPrice.toFixed(2),
          discount: itemPrice && discountFactor > 0 ? +(+itemPrice - +discountedPrice).toFixed(2) : 0,
          quantity: orderInformation.items[item].quantity,
          condition: orderInformation.items[item].product?.reconditionned ? 'refurbished' : 'new',
        };
      }),
    },
  });

  const purchaseReturnEvent = (order, orderInformation, isNewCustomer, vatRate) => {
    let itemsTotalQuantity = 0;
    let productsAmountExcludingVat = 0;
    orderInformation.items.forEach((item) => {
      itemsTotalQuantity += item.quantity;
      if (item.product.tax_excluded || orderInformation.vat_disabled) {
        productsAmountExcludingVat += item.unit_price * item.quantity;
      } else {
        productsAmountExcludingVat += (item.unit_price / (1 + vatRate)) * item.quantity;
      }
    });
    return {
      event: 'purchase',
      ecommerce: {
        transaction_id: order.short_order_id,
        value: orderInformation.products_amount,
        shipping: orderInformation.shipping_amount,
        currency: orderInformation.currency?.alpha3_code,
        items: Object.keys(orderInformation.items).map((item, key) => {
          const itemPrice = orderInformation.items[item].product?.priceDto?.priceIncludingAllTaxes || 0;
          const discountFactor = orderInformation.items[item].product?.priceDto?.discountFactor || 0;
          const discountedPrice = orderInformation.items[item].product?.priceDto?.discountedPriceIncludingAllTaxes || 0;
          const eventPrice = discountFactor > 0 ? discountedPrice : itemPrice || 0;
          return {
            index: key,
            item_id: orderInformation.items[item].product?.category?.code === 'serenity_pack' ? '20' : orderInformation.items[item].product?.sku,
            item_name: orderInformation.items[item].product?.category?.code === 'serenity_pack' ? 'Assurance' : orderInformation.items[item].product?.name,
            item_category: orderInformation.items[item].product?.category?.code === 'serenity_pack' ? 'Services' : orderInformation.items[item].product?.category?.name,
            price: +eventPrice.toFixed(2),
            discount: itemPrice && discountFactor > 0 ? +(+itemPrice - +discountedPrice).toFixed(2) : 0,
            quantity: orderInformation.items[item].quantity,
            condition: orderInformation.items[item].product?.reconditionned ? 'refurbished' : 'new',
          };
        }),
      },
      custom: {
        quantity: itemsTotalQuantity,
        payment_type: order.consolidation?.payment?.name,
        new_customer: isNewCustomer,
        value_excl_tax: +productsAmountExcludingVat.toFixed(2),
      },
    };
  };

  return {
    reset,
    signUpEvent,
    signInEvent,
    viewItemsListEvent,
    viewItemEvent,
    addToWishlistEvent,
    addToCartEvent,
    addSerenityPackToCartEvent,
    viewCartEvent,
    removeFromCartEvent,
    removeSerenityPackFromCartEvent,
    beginCheckoutEvent,
    addShippingInfoEvent,
    addPaymentInfoEvent,
    purchaseReturnEvent,
  };
}
